<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>利用サービス申請詳細</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <h2>現在の利用希望サービス</h2>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12">
        <mp-input-box>
          <ul v-if="view.services.length" class="serviceList">
            <li v-for="s in view.services" :key="s.serviceId">
              {{ s.serviceNameJp }}
            </li>
          </ul>
          <p v-else>利用希望サービスは、ありません。</p>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <h2>利用希望サービス申請</h2>
      </v-col>
    </v-row>

      <v-col cols="12">
        <v-data-table
          item-key="serviceId"
          :single-select="false"
          :headers="headers"
          :items="view.serviceApplications"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          hide-default-footer
          mobile-breakpoint=0
          disable-pagination
          class="elevation-1"
        >
          <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.serviceNameJp }}</td>
            <td>{{ item.entryDt }}</td>
            <td>
              <mp-input-box min>
                <v-select
                  v-model="item.entryStatus"
                  :items="view.entryStatusList"
                  item-text="text"
                  item-value="value"
                  label="選択してください"
                  id=""
                  hide-details
                  solo
                  dense
                  color="green"
                  item-color="green"
                  :disabled="!isOperableService(item.serviceId)"
                ></v-select>
              </mp-input-box>
            </td>
          </tr>
          </template>
        </v-data-table>
      </v-col>

  <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button
          wide
          @click="goModify"
        >
          変更を保存する
        </mp-button>
        <mp-dialog modify :show="view.dialog.modifyComplete" @clickOk="goList"/>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <h2>アカウント情報</h2>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ID</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>{{ view.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>氏名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.name }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>所属</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.groupLarge.groupLargeName.ja }}<span class="mx-2">＞</span>{{ view.groupSmall.groupSmallName.ja }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.companyLabel.ja }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.companyName }}</mp-input-box>
        <mp-input-box>{{ view.companyNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.branchLabel.ja }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.branchName }}</mp-input-box>
        <mp-input-box>{{ view.branchNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>郵便番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.postNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>都道府県</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ $store.getters.prefNameByCode(view.prefCd).ja }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>市区町村</mp-label>
      </v-col>
      <v-col cols="8" dense>
        <mp-input-box>{{ view.addr1 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>番地</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr2 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ビル名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr3 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>部署</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.busho }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>電話番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.telNo }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>備考</mp-label>
      </v-col>
      <v-col cols="8" class="pr-0">
        <mp-multiple-lines-input-box>{{ view.remarks }}</mp-multiple-lines-input-box>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import { AdminAccountServiceApplication, Common } from '@/api'
import MpError from '@/components/item/MpError'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'
import MpDialog from '@/components/item/MpDialog.vue'

export default {
  name: 'AdminAccountServiceApplicationDetail',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpMultipleLinesInputBox,
    MpDialog
  },
  data: () => ({
    form: {
      accountId: '',
      serviceApplications: []
    },
    view: {
      errors: [],
      mailAddress: '',
      name: '',
      groupLarge: {
        groupLargeName: {
          ja: '',
          en: ''
        }
      },
      groupSmall: {
        groupSmallName: {
          ja: '',
          en: ''
        },
        companyLabel: {
          ja: ''
        },
        branchLabel: {
          ja: ''
        }
      },
      companyName: '',
      companyNameKana: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      serviceApplications: [],
      entryStatusList: [],
      userServices: [],
      originalServiceApplications: [],
      dialog: {
        modifyComplete: false
      }
    }
  }),
  computed: {
    headers () {
      return [
        {
          text: '申請サービス',
          value: 'serviceName',
          sortable: false,
          width: '40%'
        },
        {
          text: '申請日時',
          value: 'entryDt',
          sortable: false,
          width: '30%'
        },
        {
          text: '申請ステータス',
          value: 'entryStatus',
          sortable: false,
          width: '30%'
        }
      ]
    }
  },
  methods: {
    goList () {
      // 一覧画面に戻る
      this.$router.push({ path: '/admin/account/service/application/list' })
    },
    async goModify () {
      this.form.serviceApplications = this.view.serviceApplications.map(s => {
        return {
          serviceId: s.serviceId,
          entryStatus: s.entryStatus
        }
      })
      await AdminAccountServiceApplication.update(this.form)
        .then(() => {
          this.view.dialog.modifyComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.groupSmall.companyLabel.ja = StringUtils.isEmpty(this.view.groupSmall.companyLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.company.ja')
        : this.view.groupSmall.companyLabel.ja

      this.view.groupSmall.branchLabel.ja = StringUtils.isEmpty(this.view.groupSmall.branchLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.ja')
        : this.view.groupSmall.branchLabel.ja
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    isOperableService (serviceId) {
      const service = this.view.originalServiceApplications.find((v) => {
        return serviceId === v.serviceId
      })
      return service && this.view.userServices.includes(serviceId)
    }
  },
  created: async function () {
    this.view.errors = []
    // パラメータからアカウント申請IDを取得
    this.form.accountId = this.$route.params.id

    // アカウント情報取得
    const result = await AdminAccountServiceApplication.detail({ accountId: this.form.accountId })
      .catch(error => { this.view.errors = error.messages })
    this.view = { ...this.view, ...result }

    this.view.originalServiceApplications = this.view.serviceApplications.map(s => ({ ...s }))

    this.view.entryStatusList = [
      { text: '審査中', value: '1' },
      { text: '承認', value: '2' },
      { text: '却下', value: '3' }
    ]

    await this.setDefaultLabel()
  }
}
</script>

<style scoped>
  .v-icon.mdi-new-box {
    color: #E62233;
  }
  .serviceList{
    margin-bottom: 16px;
  }
</style>
